import React from "react";
import {
  MDBCard,
  MDBCardTitle,
  MDBCol,
  MDBIcon,
  MDBView,
  MDBMask,
} from "mdbreact";
import Transition from "../../components/TransitionModal/TransitionModalNoButton.jsx";
import Button from "@material-ui/core/Button";
import SingleCardStyle from "./SingleCardStyle.css";

const topChars = (_string, title) => {
  let mystring;
  /*   if (title.length>43)
    mystring = _string.substring(0, 125);
  else
    mystring = _string.substring(0,137-title.length);
 */
  mystring = _string.substring(0, 125);
  return mystring;
};

const SingleCard = (props) => {
  return (
    <MDBCol className="col d-flex align-items-stretch">
      <MDBView hover className="z-depth-5 card-custom">
        <MDBCard
          className="card-image shadow-box-example pattern-1 "
          style={{
            backgroundImage: `url(${props.path})`,
          }}
        >
          <div className="card-overlay-custom overlay-custom text-white text-center d-flex align-items-center rgba-black-strong py-5 px-4">
            <div>
              <MDBCardTitle
                tag={props.title.length > 44 ? "h4" : "h3"}
                className="card-title pt-2"
              >
                <strong>{props.title}</strong>
              </MDBCardTitle>
              <p>{`${topChars(props.description, props.title)}...`}</p>
            </div>
          </div>
        </MDBCard>
        <MDBMask className="flex-center" overlay="cyan-strong">
          <Transition description={props.description} title={props.title}>
            <div>
              <Button role="button" color="white">
                <MDBIcon icon="clone left" /> {props.servicesButton}
              </Button>
            </div>
          </Transition>
        </MDBMask>
      </MDBView>
    </MDBCol>
  );
};

export default SingleCard;



// WEBPACK FOOTER //
// ./src/components/MDBCard/SingleCard.jsx